import { apiClient } from './client'
import type { AdminUser, UsersListResponse, UpdateUserRoleRequest } from '@/types/models'

export const adminApi = {
  /**
   * List all users with pagination (admin only)
   */
  async listUsers(params?: { limit?: number; offset?: number }): Promise<UsersListResponse> {
    return apiClient.get<UsersListResponse>('/api/v1/admin/users', { params })
  },

  /**
   * Get a single user with stats (admin only)
   */
  async getUser(id: string): Promise<AdminUser> {
    return apiClient.get<AdminUser>(`/api/v1/admin/users/${id}`)
  },

  /**
   * Update a user's role (admin only)
   */
  async updateUserRole(id: string, role: 'user' | 'admin'): Promise<AdminUser> {
    const body: UpdateUserRoleRequest = { role }
    return apiClient.put<AdminUser>(`/api/v1/admin/users/${id}/role`, body)
  },

  /**
   * Delete a user (admin only)
   */
  async deleteUser(id: string): Promise<void> {
    await apiClient.delete(`/api/v1/admin/users/${id}`)
  },
}
